import { useMemo } from 'react';
import BusinessHoursSelection from '@features/BusinessHoursSelection';
import { Hint } from '@features/ChannelsForms/FormSection';
import { formatTimeZoneLabel, getBrowserTimeZone } from '@helpers/dates';
import type { BusinessHours, BusinessHoursDay } from '@helpers/business-hours';
import { useTranslation } from '@hooks';

type Props = {
    value: BusinessHours;
    onChange: (value: BusinessHours) => void;
    hint?: string;
    disabled?: boolean;
};

const BusinessHoursField = ({ value, onChange, hint, disabled = false }: Props) => {
    const { t } = useTranslation();
    const timeZone = useMemo(getBrowserTimeZone, []);
    const zoneLine = t('common.timesInZone', { timeZone: formatTimeZoneLabel(timeZone) });

    return (
        <>
            <Hint sx={{ marginTop: '-4px' }}>{hint ? `${hint} ${zoneLine}` : zoneLine}</Hint>
            <BusinessHoursSelection
                data={value?.days}
                onChangeHours={(days: BusinessHoursDay[]) => onChange({ ...value, days })}
                disabled={disabled}
            />
        </>
    );
};

export default BusinessHoursField;
